// @flow

import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { getOperatorSettings, getWhitelabelAppSettings } from './api/settings';
import Loader from './components/Loader';
import withContext from './utils/withContext';
import theme from './theme';

// this is copied from the default index.html for now
const loadingLoaderStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: '#eee',
  fontSize: '2.5em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

type State = {
  strings: *,
  settings: *,
  config: *,
};

const setFavicon = url => {
  const old = document.querySelector("link[rel*='icon']");
  const link = document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = url;
  const head = ((document.head: any): HTMLElement);
  if (old) {
    head.removeChild(old);
  }
  head.appendChild(link);
};

class WhiteLabelProvider extends React.Component<
  { children: React.Node },
  State
> {
  state = {
    strings: null,
    settings: null,
    config: null,
  };

  static childContextTypes = {
    strings: PropTypes.object,
    settings: PropTypes.object,
    config: PropTypes.object,
  };

  getChildContext = () => ({
    strings: this.state.strings,
    settings: this.state.settings,
    config: this.state.config,
  });

  componentWillMount() {
    // all of these names are terrible
    const config = resp => resp.data;
    const whiteLabel = ({ data }) => ({
      displayname: data.whitelabel_displayname,
      backgroundUrl: data.whitelabel_main_background_url,
      operatorId: data.operatorId,
      favicon: data.whitelabel_fleet_favicon_url,
      privacyUrl: data.privacyurl,
      termsUrl: data.termsurl,
    });

    Promise.all([
      getOperatorSettings(),
      getWhitelabelAppSettings(),
    ]).then(([operatorSettings, configSettings]) => {
      this.setState(
        {
          settings: whiteLabel(operatorSettings),
          config: config(configSettings),
        },
        () => {
          // here we configure the page <head />, but we want to wait until after
          // state flushes to do this work
          if (this.state.settings) {
            setFavicon(this.state.settings.favicon);
          }
        }
      );
    });
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        {this.state.settings === null ? (
          <div style={loadingLoaderStyle}>
            <Loader center />
          </div>
        ) : (
          this.props.children
        )}
      </ThemeProvider>
    );
  }
}

export const withWhiteLabel = withContext(WhiteLabelProvider.childContextTypes);

export default WhiteLabelProvider;



// WEBPACK FOOTER //
// ./src/WhiteLabelProvider.js